{
    "LoadingLabel": "[Caricamento...]",
    "NAME": "ComboBox"
}